<template>
  <div class="top-bar--right">
    <b-button v-if="showEdit" size="-small" variant="-txt" v-b-modal.edit-computer @click="handleOpenEditHost">{{$t('buttons.edit')}}</b-button>

    <b-modal v-model="openEditHost" id="edit-computer" modal-class="modal--edit">
      <edit-host ref="editHostComponent" :host-id="host.host_id" :host-name="hostName" :host-color="host.host_color"></edit-host>
      <template v-slot:modal-footer="{ cancel, ok }">
        <div class="modal__footer--left">
          <b-button variant="-gray" @click="cancel()">
            {{$t('buttons.close')}}
          </b-button>
        </div>
        <div class="modal__footer--right">
          <b-button variant="-primary" @click="$refs['editHostComponent'].handleEditHost(ok)">
            {{$t('printers.buttons.saveChanges')}}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import PrinterMixin from '@/mixins/printer';

  import EditHost from "../modal/EditHost";

  export default {
    name: 'host-actions',
    components: {EditHost},
    props: ['host', 'hostIndex', 'printers'],
    mixins: [PrinterMixin],
    data() {
      return {
        openEditHost: false
      }
    },
    computed: {
      showEdit() {
        let minOwnershipId = this.printers[0].printer_ownership_id;
        if (this.printers.length > 1) {
          for (let i = 1; i < this.printers.length; i++) {
            if (this.printers[i].printer_ownership_id < minOwnershipId) {
              minOwnershipId = this.printers[i].printer_ownership_id;
            }
          }
        }

        return this.canAccessAsOwner(minOwnershipId);
      },

      hostName() {
        return this.host.host_name ? this.host.host_name : this.host.host_name_calculated;
      }
    },
    methods: {
      handleOpenEditHost() {
        this.openEditHost = true;
      }
    }
  }
</script>